import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper height100" }
const _hoisted_2 = { class: "py-8 my-4" }
const _hoisted_3 = { style: {"vertical-align":"top"} }
const _hoisted_4 = { style: {"vertical-align":"top"} }
const _hoisted_5 = { style: {"vertical-align":"top"} }
const _hoisted_6 = { style: {"vertical-align":"top"} }
const _hoisted_7 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "height100"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.t('noEmailVerified.title')), 1)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('noEmailVerified.description')), 1),
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "１．", -1)),
                _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.t('noEmailVerified.step1')), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "２．", -1)),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.t('noEmailVerified.step2')), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "３．", -1)),
                _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.t('noEmailVerified.step3')), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", { style: {"vertical-align":"top"} }, "４．", -1)),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.t('noEmailVerified.step4')), 1)
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.t('noEmailVerified.noEmailTitle')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('noEmailVerified.noEmailDescription')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.reSignIn,
            color: "primary",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('noEmailVerified.loginButton')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.logout,
            color: "primary",
            outlined: "",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('noEmailVerified.reLoginButton')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}